import moment from "moment";
import apiClient from "./apiClient";
import { saveAs } from 'file-saver';
import { getCountryId, getUserRole, getSelectedCountryId } from "utils/storage";


/** Events Section */
/**
 * Fetches all events.
 * @param {number} id - The user ID.
 * @returns {Promise<Object>} - The user object.
 */
export const getAllEvents = async () => {
    const role = getUserRole();
    const fixedCountryId = getCountryId();
    let countryId = fixedCountryId;
    if (role === 1 || role === '1') {countryId = getSelectedCountryId() || '';}
    let url;
    if (role === 5 || role === '5') {url = `/events/admin-all-events?countryId=${fixedCountryId}`;
    } else {const params = new URLSearchParams({page: '1',limit: '1000'});
        if (countryId) {params.append('countryId', countryId);}
        url = `/events/admin-all-events?${params.toString()}`;
    }
    const response = await apiClient.get(url);
    return response?.data;
};

export const getEventBySlug = async (slug) => {
    const response = await apiClient.get(`/events/${slug}`);
    return response.data;
};

export const getEventById = async (id) => {
    const response = await apiClient.get(`/events/event-by-id/${id}`);
    return response.data;
};
//update event
export const updateEvent = async (id, data) => {
    const response = await apiClient.put(`/events/${id}`, data);
    return response.data;
};
//contact
export const getContactsByEvent = async () => {
    try {
        const response = await apiClient.get(`/contacts`);
        return response.data;
        // Assuming the API returns an array of contacts
    } catch (error) {
        console.error("Error fetching contacts:", error);
        throw error;
    }
};


/** Ticket Section */

/**
 * Fetches all tickets by slug.
 * @param {string} slug - The user ID.
 * @returns {Promise<Object>} - The user object.
 */

export const getAllTicketsBySlug = async (slug) => {
    const response = await apiClient.get(`/ticket-type/${slug}`);
    return response.data;
};


/** Booking  Section */

export const createBooking = async (data) => {
    const response = await apiClient.post('/booking', data);
    return response.data;
};
export const createFreeBooking = async (data) => {
    const response = await apiClient.post('/v2/booking/create-free-booking-single-group', data);
    return response.data;
};

export const sendGroupEmailConfirmation = async (bookingNo) => {
    const response = await apiClient.get(`/booking/send-group-confirmation/${bookingNo}`);
    return response.data;
}
export const getBookingPayment = async (bookingNo) => {
    const response = await apiClient.get(`/booking/payment/${bookingNo}`);
    return response.data;
}

export const getBookingDetails = async (bookingNo) => {
    const response = await apiClient.get(`/booking/${bookingNo}`);
    return response.data;
}

export const getBookingDetailsV2 = async (bookingNo) => {
    const response = await apiClient.get(`/v2/booking/booking-by-no/${bookingNo}`);
    return response.data;
}

export const sendEmailConfirmation = async (bookingNo) => {
    const response = await apiClient.get(`/booking/send-confirmation/${bookingNo}`);
    return response.data;
}

export const updateBookingConfirmation = async (bookingId, data) => {
    const response = await apiClient.put(`/booking/${bookingId}`, data);
    return response.data;
}



//Admin API
export const getAllOrganizer = async () => {
  const role = Number(getUserRole());
  const fixedCountryId = getCountryId();
  let countryId = fixedCountryId;
  if (role === 1) {countryId = getSelectedCountryId() || '';}
  const params = new URLSearchParams({page: '1',limit: '1000',});
  if (role === 5) {params.set('countryId', fixedCountryId);} 
  else if (countryId) {params.set('countryId', countryId);}
  const url = `/organizer/?${params.toString()}`;
  const response = await apiClient.get(url);
  return response?.data;
};
export const getAllBookingByEvent = async (slugId) => {
    const response = await apiClient.get(`/booking/event/${slugId}`);
    return response.data;
}
export const getAllBookingByOrganizer = async () => {
    const response = await apiClient.get(`/booking/organizer`);
    return response.data;
}

export const getAllBookingByOrganizerId = async (organizerId) => {
    const response = await apiClient.get(`/booking/get-organizer-booking-admin/${organizerId}`);
    return response.data;
}

export const getAllBookingByDateRange = async (from, to) => {
    const response = await apiClient.get(`/v2/search/date-wise-eventox-revenue`, {
        params: { from, to },
    });
    return response.data;
};

//get all event by event id
export const getBookingByEventId = async (eventId) => {
    const response = await apiClient.get(`/booking/booking-by-event/${eventId}`);
    return response.data;
}
//get all booking by venue id and event id
export const getBookingByVenueIdAndEventId = async (venueId, eventId) => {
    const response = await apiClient.get(`/booking/booking-by-event-and-venue/${eventId}/${venueId}`);
    return response.data;
}
// Get all countries
export const getAllCountries = async () => {
    const response = await apiClient.get('/countries');
    return response.data;
};

//create Organizer

export const createOrganizer = async (data) => {
    const response = await apiClient.postForm('/users', data);
    return response.data;
};
//Update user
export const updateUser = async (id, data) => {
    const response = await apiClient.put(`/users/${id}`, data);
    return response.data;
};
//Update organizer
export const updateOrganizer = async (id, data) => {
    const response = await apiClient.patch(`/v2/organizers/${id}`, data);
    return response.data;
};
//delete user
export const deleteUser = async (id) => {
    const response = await apiClient.delete(`/users/${id}`);
    return response.data;
};


//get all event by organizer
export const getAllEventByOrganizer = async () => {
    const response = await apiClient.get(`/events/organizer`);
    return response.data;
}

//get all event categorysss
export const getAllEventCategory = async () => {
    const response = await apiClient.get(`/categories`);
    return response.data;
}

//create event
export const createEvent = async (data) => {
    const response = await apiClient.postForm('/events', data);
    return response.data;
};
//delete event
export const deleteEvent = async (id) => {
    const response = await apiClient.delete(`/events/${id}`);
    return response.data;
};

//get event by query
export const getEventByQuery = async (filedName, filedValue) => {
    const response = await apiClient.get(`/events/query/${filedName}/${filedValue}`);
    return response.data;
}
//get all ticket by event
export const getAllTicketByEvent = async (eventId) => {
    const response = await apiClient.get(`/ticket-type/${eventId}`);
    return response.data;
}
//create ticket
export const createTicket = async (data) => {
    const response = await apiClient.post('/ticket-type', data);
    return response.data;
};

//delete ticket
export const deleteTicket = async (id) => {
    const response = await apiClient.delete(`/ticket-type/${id}`);
    return response.data;
};
//update ticket
export const updateTicket = async (id, data) => {
    const response = await apiClient.put(`/ticket-type/${id}`, data);
    return response.data;
};

//fetch forum by slug
export const getForumBySlug = async (slug) => {
    const response = await apiClient.get(`/form/forms/${slug}`);
    return response.data;
}

//get all sponsors
export const getAllSponsors = async () => {
    const response = await apiClient.get(`/sponsor`);
    return response.data;
}

//create sponsor
export const createSponsor = async (data) => {
    const response = await apiClient.post('/sponsor', data);
    return response.data;
}

//delete sponsor
export const deleteSponsor = async (id) => {
    const response = await apiClient.delete(`/sponsor/${id}`);
    return response.data;
}

//get sponsor by eventSlug
export const getSponsorByEventSlug = async (slug) => {
    const response = await apiClient.get(`/sponsor/event/${slug}`);
    return response.data;
}

//get all sponsor types
export const getAllSponsorTypes = async () => {
    const response = await apiClient.get(`/sponsor-type`);
    return response.data;
}


export const downloadBookingDetails = async (eventId, venueId) => {
    try {
        const response = await apiClient.post(`/export/export-by-event/${eventId}/${venueId}`, {}, { responseType: 'blob' });


        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const saveFileName = `bookings-${moment(new Date()).format('DD-MMM-YYYY')}.xlsx`;
        saveAs(blob, saveFileName);
    } catch (error) {
        console.log(error);
    }
}
export const downloadBookingDetailsPdf = async (eventId, venueId) => {
    try {
        const response = await apiClient.post(`/export/export-by-event-pdf/${eventId}/${venueId}`, {}, { responseType: 'blob' });
        const blob = new Blob([response.data], {
            type: 'application/pdf',
        });
        const saveFileName = `bookings-${moment(new Date()).format('DD-MMM-YYYY')}.pdf`;
        saveAs(blob, saveFileName);
    } catch (error) {
        console.log(error);
    }
}


export const getEventVenuesBySlug = async (slug) => {
    const response = await apiClient.get(`/event-venue/${slug}`);
    return response.data;

}

export const getAllTicketByEventAndVenue = async (eventId, venueId) => {
    const response = await apiClient.get(`/ticket-type/ticket-by-venue-event/${venueId}/${eventId}`);
    return response.data;
}

export const createEventVenue = async (data) => {
    const response = await apiClient.post('/event-venue', data);
    return response.data;
}

export const updateEventVenue = async (id, data) => {
    const response = await apiClient.put(`/event-venue/${id}`, data);
    return response.data;
}



//get all coupon
export const getAllCoupon = async () => {
    const role = getUserRole();
    const fixedCountryId = getCountryId();
    let countryId = fixedCountryId;
    if (role === 1 || role === '1') {countryId = getSelectedCountryId() || '';}
    const params = new URLSearchParams();
    if (role === 5 || role === '5') {params.append('countryId', fixedCountryId);
    } else if (countryId) {params.append('countryId', countryId);}
    const url = `/coupon?${params.toString()}`;
    const response = await apiClient.get(url);
    return response.data;
}
//get organizer coupon
export const getOrganizerCoupon = async () => {
    const response = await apiClient.get(`/coupon/organizer`);
    return response.data;
}
//create admin coupon
export const createAdminCoupon = async (data) => {
    const response = await apiClient.post('/coupon', data);
    return response.data;
}
//create organizer coupon
export const createOrganizerCoupon = async (data) => {
    const response = await apiClient.post('/coupon', data);
    return response.data;
}
//update organizer coupon
export const updateOrganizerCoupon = async (id, data) => {
    const response = await apiClient.put(`/coupon/${id}`, data);
    return response.data;
}

//spot booking
export const createSpotBooking = async (data) => {
    const response = await apiClient.post('/spot-booking', data);
    return response.data;
}

export const getAllSpotBooking = async () => {
    const response = await apiClient.get(`/spot-booking`);
    return response.data;
}
export const deleteSpotBooking = async (id) => {
    const response = await apiClient.delete(`/spot-booking/${id}`);
    return response.data;
}

export const getTicketSummery = async (eventId) => {
    const response = await apiClient.get(`/booking/ticket-sales-by-event/${eventId}`);
    return response.data;
}

//get all ticket group
export const getAllTicketGroup = async () => {
    const response = await apiClient.get(`/ticket-group`);
    return response.data;
}
//create ticket group
export const createTicketGroup = async (data) => {
    const response = await apiClient.post('/ticket-group', data);
    return response.data;
}
export const updateTicketGroup = async (id, data) => {
    const response = await apiClient.patch(`/ticket-group/${id}`, data);
    return response.data;
}

export const deleteTicketGroup = async (id) => {
    const response = await apiClient.delete(`/ticket-group/${id}`);
    return response.data;
}
export const getTicketTypesBySlugId = async (slugId) => {
    const response = await apiClient.get(`/ticket-type/${slugId}`);
    return response.data;
};


//get booking slot by id
export const getBookingSlotById = async (id) => {
    const response = await apiClient.get(`/booking-slot/${id}`);
    return response.data;
}

//create booking slot
export const createBookingSlot = async (data) => {
    const response = await apiClient.post('/booking-slot', data);
    return response.data;
}

//update booking slot
export const updateBookingSlot = async (id, data) => {
    const response = await apiClient.put(`/booking-slot/${id}`, data);
    return response.data;
}

//delete booking slot
export const deleteBookingSlot = async (id) => {
    const response = await apiClient.delete(`/booking-slot/${id}`);
    return response.data;
}

//get booking slot by ticket group id
export const getBookingSlotByTicketGroupId = async (id) => {
    const response = await apiClient.get(`/booking-slot/ticket-group/${id}`);
    return response.data;
}

//get booking slot by event slug
export const getBookingSlotByEventSlug = async (slug) => {
    const response = await apiClient.get(`/booking-slot/slug/${slug}`);
    return response.data;
}

// Comprehensive booking search API
export const searchBookings = async (searchParams) => {
    try {
        const response = await apiClient.get('/booking/search', {
            params: searchParams
        });
        return response.data;
    } catch (error) {
        console.error("Error searching bookings:", error);
        throw error;
    }
};

// Search bookings by email or phone
export const searchBookingsByContact = async (searchTerm) => {
    try {
        const response = await apiClient.get('/v2/search/search-contact', {
            params: { searchTerm }
        });
        return response.data;
    } catch (error) {
        console.error("Error searching bookings by contact:", error);
        throw error;
    }
};

// Get all bookings with filters
export const getAllBookingsWithFilters = async (filters = {}) => {
    try {
        const response = await apiClient.get('/booking/all-with-filters', {
            params: filters
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching bookings with filters:", error);
        throw error;
    }
};
export const createUserByOrganizer = async (id, data) => {
    const response = await apiClient.post(`/users/organizer/${id}/user`, data);
    return response.data;
}

export const getUsersByOrganizer = async (id) => {
    const response = await apiClient.get(`/users/organizer/${id}/users`);
    return response.data;
}


export const updateUserByOrganizer = async (organizerId, data) => {
    const response = await apiClient.put(`/users/organizer/user/${organizerId}`, data);
    return response.data;
}


export const deleteUserByOrganizer = async (id) => {
    const response = await apiClient.delete(`/users/organizer/user/${id}`);
    return response.data;
}

//cancel booking
export const cancelBooking = async (data) => {
    const response = await apiClient.patch(`/booking/cancel`, data);
    return response;
};

//Entitlements
export const getEntitlements = async () => {
    const response = await apiClient.get(`/entitlements`);
    return response.data.data;
};

export const createEntitlement = async (data) => {
    const response = await apiClient.post(`/entitlements`, data);
    return response.data.data;
};

export const updateEntitlement = async (id, payload) => {
    const res = await apiClient.put(`/entitlements/${id}`, payload);
    return res.data.data || res.data;
};

export const deleteEntitlement = async (id) => {
    const res = await apiClient.delete(`/entitlements/${id}`);
    return res.data.data || res.data;
};
//create Venue

export const createVenue = async (formData) => {
    const res = await apiClient.post("/users", formData);
    return res.data;
};
export const getAllVenue = async () => {
    const role = getUserRole();
    const fixedCountryId = getCountryId();
    let countryId = fixedCountryId;
    if (role === 1 || role === '1') { countryId = getSelectedCountryId() || ''; }
    
    const params = new URLSearchParams();
    if (role === 5 || role === '5') {
        params.append('location', fixedCountryId);
    } else if (countryId) {
        params.append('location', countryId);
    }

    const url = `/users?${params.toString()}`;
    const res = await apiClient.get(url);
    return res.data;
};
export const updateVenue = async (id, formData) => {
    const res = await apiClient.put(`/users/${id}`, formData);
    return res.data;
};
export const deleteVenue = async (id) => {
    const res = await apiClient.delete(`/users/${id}`);
    return res.data;
};

//  DISCOVER 

export const getAllDiscover = async (page = 1, limit = 30) => {
    const response = await apiClient.get(`/discover?page=${page}&limit=${limit}`);
    return response.data;
};
export const createDiscover = async (formData) => {
    const response = await apiClient.postForm('/discover', formData);
    return response.data;
};

export const updateDiscover = async (id, data) => {
    const response = await apiClient.put(`/discover/${id}`, data);
    return response.data;
};

export const deleteDiscover = async (id) => {
    const response = await apiClient.delete(`/discover/${id}`);
    return response.data;
};
export const updateDiscoverName = async (id, eventName) => {
    const response = await apiClient.put(`/discover/${id}`, {
        eventName,
    });
    return response.data;
};

// Create Country Admin
export const createCountryAdmin = async (data) => {
    const response = await apiClient.postForm('/users', data);
    return response.data;
};
// Get all Country Admins
export const getAllCountryAdmins = async () => {
    const response = await apiClient.get('/users');
    return response.data;
};
// Update Country Admin
export const updateCountryAdmin = async (id, data) => {
    const response = await apiClient.put(`/users/${id}`, data);
    return response.data;
};
// Delete Country Admin
export const deleteCountryAdmin = async (id) => {
    const response = await apiClient.delete(`/users/${id}`);
    return response.data;
};
//List Event
export const ListEvent = async () => {
    const role = getUserRole();
    const fixedCountryId = getCountryId();
    let countryId = fixedCountryId;
    if (role === 1 || role === '1') {countryId = getSelectedCountryId() || '';}
    const params = new URLSearchParams();
    if (role === 5 || role === '5') {
        params.append('countryId', fixedCountryId);
    } else if (countryId) {
        params.append('countryId', countryId);
    }
    const url = `/event-list?${params.toString()}`;
    const response = await apiClient.get(url);
    return response.data;
};

export const createEventList = async (data) => {
    const response = await apiClient.post('/event-list', data);
    return response.data;
};

export const deleteEventList = async (id) => {
    const response = await apiClient.delete(`/event-list/${id}`);
    return response.data;
};

export const updateEventList = async (id, data) => {
    const response = await apiClient.put(`/event-list/${id}`, data);
    return response.data;
};
// Artists (CRUD)
export const getArtists = async () => {
    const response = await apiClient.get("/artists");
    return response.data?.data ?? response.data ?? [];
};

export const getArtistById = async (id) => {
    const response = await apiClient.get(`/artists/${id}`);
    return response.data?.data ?? response.data;
};

export const createArtist = async (data) => {
    const response = await apiClient.post("/artists", data);
    return response.data?.data ?? response.data;
};

export const updateArtist = async (id, data) => {
    const response = await apiClient.put(`/artists/${id}`, data);
    return response.data?.data ?? response.data;
};

export const deleteArtist = async (id) => {
    const response = await apiClient.delete(`/artists/${id}`);
    return response.data?.data ?? response.data;
};

// Inquires
export const getInquires = async () => {
    const response = await apiClient.get("/inquires");
    return response.data?.data ?? response.data ?? [];
};

export const getInquiresByRequestUser = async (requestUserId) => {
    const response = await apiClient.get(`/inquires/by-request-user/${requestUserId}`);
    return response.data?.data ?? response.data ?? [];
};

export const getInquiresByTargetUser = async (targetUserId) => {
    const response = await apiClient.get(`/inquires/by-target-user/${targetUserId}`);
    return response.data?.data ?? response.data ?? [];
};

export const getInquireById = async (id) => {
    const response = await apiClient.get(`/inquires/${id}`);
    return response.data?.data ?? response.data;
};

export const createInquire = async (data) => {
    const response = await apiClient.post("/inquires", data);
    return response.data?.data ?? response.data;
};

export const updateInquire = async (id, data) => {
    const response = await apiClient.put(`/inquires/${id}`, data);
    return response.data?.data ?? response.data;
};

// Public venues
export const getPublicVenues = async () => {
    const response = await apiClient.get("/public-venues");
    return response.data?.data ?? response.data ?? [];
};

export const getPublicVenuesByUser = async (createdBy) => {
    const response = await apiClient.get(`/public-venues/by-user/${createdBy}`);
    return response.data?.data ?? response.data ?? [];
};

export const getPublicVenueById = async (id) => {
    const response = await apiClient.get(`/public-venues/${id}`);
    return response.data?.data ?? response.data;
};

export const createPublicVenue = async (data) => {
    const response = await apiClient.post("/public-venues", data);
    return response.data?.data ?? response.data;
};

export const updatePublicVenue = async (id, data) => {
    const response = await apiClient.put(`/public-venues/${id}`, data);
    return response.data?.data ?? response.data;
};

export const deletePublicVenue = async (id) => {
    await apiClient.delete(`/public-venues/${id}`);
};


// Download ticket - responseType 'blob' is required for binary PDF data
export const downloadTicketByBookingNo = async (bookingNo) => {
    const response = await apiClient.get(`/v2/booking/download-ticket/${bookingNo}`, {
        responseType: 'blob'
    });
    return response.data;
}
//Refunds
export const refundAllByEventId = async (eventId) => {
    const response = await apiClient.post(`/events/${eventId}/refund-all`, {});
    return response.data;
};

export const refundByBookingNo = async (bookingNo) => {
    try {
        const response = await apiClient.post(`/booking/${bookingNo}/refund`, {});
        return response.data;
    } catch (error) {
        console.error("Error refunding booking:", error);
        throw error;
    }
};